export const HEADER_SELECTORS = '.header, .mc-navbar, .simple-header';

export default function getHeaderOffset() {
  const firstHeader = document.querySelector(HEADER_SELECTORS);
  if(firstHeader && ['sticky', 'fixed'].indexOf(getComputedStyle(firstHeader).position) > -1) {
    return firstHeader.offsetHeight;
  } else {
    return 0;
  }
}
